module.exports = __webpack_public_path__ + "static/media/Dec_2025_1.ca72f28e.webp";